'use strict';
/* Kalis/Claude - all reviews page: replace judge.me's subtab row with a dropdown.
 *
 * The page header is laid out like the product page - stars hard left, write-review button
 * hard right. judge.me's own control row (.jdgm-rev-widg__actions: the two subtabs plus the
 * sort dropdown) is hidden in kalis.css, and this builds a <select> in its place, inserted
 * just before the write-review button inside .jdgm-row-stars.
 *
 * Switching tabs still goes through judge.me's own subtab links - the select just calls
 * .click() on them, which works even though they are display:none. Nothing about judge.me's
 * tab logic is reimplemented here.
 *
 * The build is idempotent and re-runs on judge.me's events, because judge.me re-renders the
 * header when a tab is switched or the list is filtered, which would otherwise drop or
 * duplicate the select. Option labels are re-read every pass so they pick up the thousands
 * separators applied by kalis-judgeme-number-format.js, whichever order the two run in.
 */

(function () {
  var SELECT_CLASS = 'kalis-jdgm-tabselect';

  function subtabs() {
    return [].slice.call(document.querySelectorAll('#judgeme_all_reviews_page .jdgm-subtab__name'));
  }

  function build() {
    var row = document.querySelector('#judgeme_all_reviews_page .jdgm-row-stars');
    if (!row) return;
    var actions = row.querySelector('.jdgm-widget-actions-wrapper');
    var tabs = subtabs();
    if (tabs.length < 2) return;                 // nothing to switch between

    var sel = row.querySelector('.' + SELECT_CLASS);
    if (!sel) {
      sel = document.createElement('select');
      sel.className = SELECT_CLASS;
      // Do not hardcode a language here - this ships to 8 storefronts. judge.me's own
      // setting is already translated per store; fall back to no label rather than a
      // Norwegian one on a German storefront.
      var label = (window.jdgmSettings && (jdgmSettings.widget_reviews_subtab_text ||
                   jdgmSettings.widget_product_reviews_subtab_text)) || '';
      if (label) sel.setAttribute('aria-label', label);
      sel.addEventListener('change', function () {
        // re-query: judge.me may have re-rendered since this listener was attached
        var current = subtabs();
        var target = current[parseInt(sel.value, 10)];
        if (target) target.click();
      });
      if (actions) row.insertBefore(sel, actions);
      else row.appendChild(sel);
    }

    var labels = tabs.map(function (t) { return t.textContent.trim(); });
    var signature = labels.join('|');
    if (sel.dataset.labels !== signature) {
      sel.innerHTML = '';
      labels.forEach(function (label, i) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = label;
        sel.appendChild(opt);
      });
      sel.dataset.labels = signature;
    }

    var activeIndex = tabs.findIndex(function (t) { return /jdgm--active/.test(t.className); });
    if (activeIndex >= 0 && sel.selectedIndex !== activeIndex) sel.selectedIndex = activeIndex;
  }

  var timer;
  function buildSoon() {
    clearTimeout(timer);
    timer = setTimeout(build, 60);
  }

  ['jdgm.doneSetup', 'jdgm.doneSetupReviews', 'jdgm.doneAppendMoreReviewsInAllReviewsPage',
   'jdgm.openedTabInAllReviewsPage', 'jdgm.filteredInAllReviewsPage',
   'jdgm.doneShowReviewsTab'].forEach(function (name) {
    document.addEventListener(name, buildSoon, false);
  });

  // The widget loads lazily and code-split, so poll briefly as a safety net (20s).
  var tries = 0;
  var poll = setInterval(function () {
    build();
    if (++tries > 40) clearInterval(poll);
  }, 500);

  buildSoon();
})();
